import { DESC, REVIEWSCHEDULER, VONBOARDER } from "../../../../../utils/Constants";
import upcommingcalls from '../../../../../assets/icons/svg/upcoming-calls.svg';
import requesttoberescheduled from '../../../../../assets/icons/svg/requested-to-be-resceduled.svg';
import myclaimedcalls from '../../../../../assets/icons/svg/my-claimed-calls.svg';
import duecalls from '../../../../../assets/icons/svg/due-calls.svg';
import activecalls from '../../../../../assets/icons/svg/active-calls.svg';
import scheduledappointments from '../../../../../assets/icons/svg/scheduled-appointments.svg';
import nonresponsivecalls from '../../../../../assets/icons/svg/non-responsive-calls.svg';
import notinterested from '../../../../../assets/icons/dashboard/sad.png'
import badphonenumber from '../../../../../assets/icons/svg/bad-phone-number.svg'



export const GET_COUNT_ROWDATA = (user_type,) => {
    let buckets = [];
    if (user_type == REVIEWSCHEDULER) {
        buckets = [{
            order: 0,
            index: 4,
            direction: DESC,
            order_by: 'expiration_date',
            title: "Upcoming Calls",
            dashboard_stats: "upcoming_calls",
            description: "Profiles for which the active call date and schedule-by date are in the future.",
            icon: upcommingcalls,
            role: REVIEWSCHEDULER,
            isLiveGrid: true,
            isClickable: false,
            quickNavigation: false,
            isRSUser: true
        },
        {
            order: 1,
            index: 2,
            direction: DESC,
            order_by: 'expiration_date',
            title: "Due Calls",
            dashboard_stats: "due_calls",
            description: "Profiles with present or expired active call date and are due to be scheduled.",
            icon: duecalls,
            role: REVIEWSCHEDULER,
            isLiveGrid: true,
            isClickable: true,
            quickNavigation: true,
            isRSUser: true
        },
        {
            order: 2,
            index: 7,
            direction: DESC,
            order_by: 'von_appointment_date',
            title: "Scheduled Appointments",
            dashboard_stats: "appointments_scheduled",
            icon: scheduledappointments,
            description: "Profiles for which appointments scheduled in the selected time frame.",
            role: REVIEWSCHEDULER,
            isLiveGrid: true,
            isClickable: true,
            quickNavigation: true,
            isRSUser: true
        },
        {
            order: 3,
            index: 1,
            direction: DESC,
            order_by: 'expiration_date',
            title: "Active Calls",
            dashboard_stats: "active_calls",
            description: "Profiles marked as not reached and their schedule-by date is not expired.",
            icon: activecalls,
            role: REVIEWSCHEDULER,
            isLiveGrid: true,
            isClickable: true,
            quickNavigation: true,
            isRSUser: true
        },
        {
            order: 4,
            index: 5,
            direction: DESC,
            order_by: 'von_appointment_date',
            title: "Non Responsive Calls",
            dashboard_stats: "non_responsive_calls",
            icon: nonresponsivecalls,
            description: "Profiles marked as non-responsive or the ones marked as not reached with expired schedule-by date.",
            role: REVIEWSCHEDULER,
            isLiveGrid: true,
            isClickable: true,
            quickNavigation: true,
            isRSUser: true
        },
        {
            order: 5,
            index: 8,
            direction: DESC,
            order_by: 'von_appointment_date',
            title: "Requested To Be Re-Scheduled",
            dashboard_stats: "requested_reschedules",
            description: "Profiles for which agents have requested appointment rescheduling.",
            icon: requesttoberescheduled,
            role: REVIEWSCHEDULER,
            isLiveGrid: true,
            isClickable: true,
            quickNavigation: true,
            isRSUser: true
        },
        {
            order: 6,
            index: 3,
            direction: DESC,
            order_by: 'von_appointment_date',
            title: "Not Interested",
            dashboard_stats: "not_interested",
            description: "Profiles that are marked as not interested.",
            icon: notinterested,
            role: REVIEWSCHEDULER,
            isLiveGrid: true,
            isClickable: true,
            quickNavigation: true,
            isRSUser: true
        },
        {
            order: 8,
            index: 6,
            direction: DESC,
            order_by: 'von_appointment_date',
            title: "Bad Phone Numbers",
            dashboard_stats: "bad_phone_number",
            description: "Profiles that are reported to have bad phone number.",
            icon: badphonenumber,
            role: REVIEWSCHEDULER,
            isClickable: true,
            quickNavigation: true,
            isRSUser: true
            // isLiveGrid: true
        }
        ]
    } else {
        buckets = [
            {
                order: 0,
                index: 4,
                direction: DESC,
                order_by: 'expiration_date',
                title: "Upcoming Calls",
                dashboard_stats: "upcoming_calls",
                description: "Profiles for which the active call date and schedule-by date are in the future.",
                icon: upcommingcalls,
                role: VONBOARDER,
                isLiveGrid: true,
                canClaimBFile: true,
                quickNavigation: true,
                isClickable: false,
                isFSUser: true
            },
            {
                order: 1,
                index: 2,
                direction: DESC,
                order_by: 'expiration_date',
                title: "Due Calls",
                dashboard_stats: "due_calls",
                description: "Profiles with present or expired active call date and are due to be scheduled.",
                icon: duecalls,
                role: VONBOARDER,
                isLiveGrid: true,
                canClaimBFile: true,
                isClickable: true,
                quickNavigation: true,
                isFSUser: true
            },
            {
                order: 2,
                index: 7,
                direction: DESC,
                order_by: 'von_appointment_date',
                title: "Scheduled Appointments",
                dashboard_stats: "appointments_scheduled",
                icon: scheduledappointments,
                description: "Profiles for which appointments scheduled in the selected time frame.",
                role: VONBOARDER,
                isLiveGrid: true,
                isClickable: true,
                quickNavigation: true,
                isFSUser: true
            },
            {
                order: 3,
                index: 1,
                direction: DESC,
                order_by: 'expiration_date',
                title: "Active Calls",
                dashboard_stats: "active_calls",
                description: "Profiles marked as not reached and their schedule-by date is not expired.",
                icon: activecalls,
                role: VONBOARDER,
                isLiveGrid: true,
                isClickable: true,
                quickNavigation: true,
                isFSUser: true
            },
            {
                order: 4,
                index: 5,
                direction: DESC,
                order_by: 'von_appointment_date',
                title: "Non Responsive Calls",
                dashboard_stats: "non_responsive",
                // dashboard_stats: "not_reached",
                icon: nonresponsivecalls,
                description: "Profiles marked as non-responsive or the ones marked as not reached with expired schedule-by date.",
                role: VONBOARDER,
                isLiveGrid: true,
                isClickable: true,
                quickNavigation: true,
                isFSUser: true
            },
            {
                order: 5,
                index: 8,
                direction: DESC,
                order_by: 'von_appointment_date',
                title: "Requested To Be Re-Scheduled",
                dashboard_stats: "requested_reschedule",
                description: "Profiles for which agents have requested appointment rescheduling.",
                icon: requesttoberescheduled,
                role: VONBOARDER,
                isLiveGrid: true,
                isClickable: true,
                quickNavigation: true,
                isFSUser: true
            },
            {
                order: 6,
                index: 3,
                direction: DESC,
                order_by: 'von_appointment_date',
                title: "Not Interested",
                dashboard_stats: "not_interested",
                description: "Profiles that are marked as not interested.",
                icon: notinterested,
                role: VONBOARDER,
                isLiveGrid: true,
                isClickable: true,
                quickNavigation: true,
                isFSUser: true
            },
            // {
            //     order: 7,
            //     index: 0,
            //     direction: DESC,
            //     order_by: 'expiration_date',
            //     title: "My Claimed Calls",
            //     dashboard_stats: "claimed_calls",
            //     icon: myclaimedcalls,
            //     description: "Profiles you claimed to schedule appointments for.",
            //     role: VONBOARDER,
            //     isLiveGrid: true,
            //     isClickable: true,
            //     quickNavigation: true,
            //     isFSUser: true
            // },
            {
                order: 8,
                index: 6,
                direction: DESC,
                order_by: 'von_appointment_date',
                title: "Bad Phone Numbers",
                dashboard_stats: "bad_phones_numbers",
                description: "Profiles that are reported to have bad phone number.",
                icon: badphonenumber,
                role: VONBOARDER,
                isClickable: true,
                quickNavigation: true,
                isFSUser: true
            },
        ]
    }
    return buckets;
}


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/review-admin/grid/RS-FS-Buckets.js